module.exports = __webpack_public_path__ + "media/tips/06_cafe-25f2e5f6.png";